import { render, staticRenderFns } from "./FormAppuntamento.vue?vue&type=template&id=19d0db77&scoped=true"
import script from "./FormAppuntamento.vue?vue&type=script&lang=js"
export * from "./FormAppuntamento.vue?vue&type=script&lang=js"
import style0 from "./FormAppuntamento.vue?vue&type=style&index=0&id=19d0db77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0db77",
  null
  
)

export default component.exports